"use strict";
exports.__esModule = true;
exports.DROPDOWN_COLORS = exports.VARIANTS = exports.ROUNDED = exports.HOVER_COLORS = exports.SIZES = exports.COLORS = void 0;
exports.COLORS = {
    primary: 'bg-primary-100 border-primary-dark text-primary-dark active:primary-dark',
    danger: 'bg-danger-100 border-danger-dark text-danger-dark active:danger-dark',
    warning: 'bg-warning-100 border-warning-dark text-warning-dark active:warning-dark',
    secondary: 'bg-secondary-100 border-secondary-dark text-secondary-dark active:secondary-dark ',
    control: 'bg-control-100 border-control-dark text-control-dark active:control-dark',
    tertiary: 'bg-tertiary-100 border-tertiary-dark text-tertiary-dark active:tertiary-dark',
    success: 'bg-success-100 border-success-dark text-success-dark active:success-dark',
    info: 'bg-info-100 border-info-dark text-info-dark active:info-dark',
    inherit: 'bg-transparent hover:bg-transparent',
    slate: 'bg-slate-100 border-slate-700 text-slate-700 active:slate-700',
    zinc: 'bg-zinc-100 border-zinc-700 text-zinc-700 active:zinc-700',
    neutral: 'bg-neutral-100 border-neutral-700 text-neutral-700 active:neutral-700',
    stone: 'bg-stone-100 border-stone-700 text-stone-700 active:stone-700',
    red: 'bg-red-100 border-red-700 text-red-700 active:red-700',
    orange: 'bg-orange-100 border-orange-700 text-orange-700 active:orange-700',
    amber: 'bg-amber-100 border-amber-700 text-amber-700 active:amber-700',
    yellow: 'bg-yellow-100 border-yellow-700 text-yellow-700 active:yellow-700',
    lime: 'bg-lime-100 border-lime-700 text-lime-700 active:lime-700',
    green: 'bg-green-100 border-green-700 text-green-700 active:green-700',
    emerald: 'bg-emerald-100 border-emerald-700 text-emerald-700 active:emerald-700',
    teal: 'bg-teal-100 border-teal-700 text-teal-700 active:teal-700',
    cyan: 'bg-cyan-100 border-cyan-700 text-cyan-700 active:cyan-700',
    sky: 'bg-sky-100 border-sky-700 text-sky-700 active:sky-700',
    blue: 'bg-blue-100 border-blue-700 text-blue-700 active:blue-700',
    indigo: 'bg-indigo-100 border-indigo-700 text-indigo-700 active:indigo-700',
    violet: 'bg-violet-100 border-violet-700 text-violet-700 active:violet-700',
    purple: 'bg-purple-100 border-purple-700 text-purple-700 active:purple-700',
    fuchsia: 'bg-fuchsia-100 border-fuchsia-700 text-fuchsia-700 active:fuchsia-700',
    pink: 'bg-pink-100 border-pink-700 text-pink-700 active:pink-700',
    rose: 'bg-rose-100 border-rose-700 text-rose-700 active:rose-700'
};
exports.SIZES = {
    huge: 'h-14 md:h-16',
    large: 'h-12 md:h-14',
    medium: 'h-10 md:h-12',
    small: 'h-8 md:h-10',
    tiny: 'h-6 md:h-8'
};
exports.HOVER_COLORS = {
    primary: 'hover:bg-primary hover:text-white',
    danger: 'hover:bg-danger hover:text-white',
    warning: 'hover:bg-warning hover:text-white',
    secondary: 'hover:bg-secondary hover:text-white',
    control: 'hover:bg-control hover:text-white',
    tertiary: 'hover:bg-tertiary hover:text-white',
    success: 'hover:bg-success hover:text-white',
    info: 'hover:bg-info hover:text-white',
    inherit: 'bg-transparent hover:bg-transparent',
    slate: 'hover:bg-slate-500 hover:text-white',
    zinc: 'hover:bg-zinc-500 hover:text-white',
    neutral: 'hover:bg-neutral-500 hover:text-white',
    stone: 'hover:bg-stone-500 hover:text-white',
    red: 'hover:bg-red-500 hover:text-white',
    orange: 'hover:bg-orange-500 hover:text-white',
    amber: 'hover:bg-amber-500 hover:text-white',
    yellow: 'hover:bg-yellow-500 hover:text-white',
    lime: 'hover:bg-lime-500 hover:text-white',
    green: 'hover:bg-green-500 hover:text-white',
    emerald: 'hover:bg-emerald-500 hover:text-white',
    teal: 'hover:bg-teal-500 hover:text-white',
    cyan: 'hover:bg-cyan-500 hover:text-white',
    sky: 'hover:bg-sky-500 hover:text-white',
    blue: 'hover:bg-blue-500 hover:text-white',
    indigo: 'hover:bg-indigo-500 hover:text-white',
    violet: 'hover:bg-violet-500 hover:text-white',
    purple: 'hover:bg-purple-500 hover:text-white',
    fuchsia: 'hover:bg-fuchsia-500 hover:text-white',
    pink: 'hover:bg-pink-500 hover:text-white',
    rose: 'hover:bg-rose-500 hover:text-white'
};
exports.ROUNDED = {
    full: 'rounded-full',
    huge: 'rounded-3xl',
    large: 'rounded-2xl',
    medium: 'rounded-lg',
    small: 'rounded',
    tiny: 'rounded-sm',
    none: 'rounded-none'
};
exports.VARIANTS = {
    filled: 'text-m-sm md:text-d-sm flex',
    outlined: 'text-control !bg-white border flex'
};
exports.DROPDOWN_COLORS = {
    primary: 'border-primary-dark',
    danger: 'border-danger-dark',
    warning: 'border-warning-dark',
    secondary: 'border-secondary-dark',
    control: 'border-control-dark',
    tertiary: 'border-tertiary-dark',
    success: 'border-success-dark',
    info: 'border-info-dark',
    inherit: 'border-inherit',
    slate: 'border-slate-700',
    zinc: 'border-zinc-700',
    neutral: 'border-neutral-700',
    stone: 'border-stone-700',
    red: 'border-red-700',
    orange: 'border-orange-700',
    amber: 'border-amber-700',
    yellow: 'border-yellow-700',
    lime: 'border-lime-700',
    green: 'border-green-700',
    emerald: 'border-emerald-700',
    teal: 'border-teal-700',
    cyan: 'border-cyan-700',
    sky: 'border-sky-700',
    blue: 'border-blue-700',
    indigo: 'border-indigo-700',
    violet: 'border-violet-700',
    purple: 'border-purple-700',
    fuchsia: 'border-fuchsia-700',
    pink: 'border-pink-700',
    rose: 'border-rose-700'
};
//# sourceMappingURL=select.style.js.map